import React from "react";
import { Grid } from "semantic-ui-react";
import HomepageStatsBasicItem from "./homepage-stats-basic-item";
import { PropTypes } from "prop-types";

const HomepageStatsBasic = ({ recordsNumber, deimsSitesNumber }) => {
  return (
    <Grid stackable centered doubling columns={3}>
      <Grid.Column>
        <HomepageStatsBasicItem
          label="Available assets"
          icon="database"
          value={recordsNumber}
        />
      </Grid.Column>
      <Grid.Column>
        <HomepageStatsBasicItem
          label="eLTER Sites covered"
          icon="map pin"
          value={deimsSitesNumber}
        />
      </Grid.Column>
      <Grid.Column>
        <HomepageStatsBasicItem
          label="Assets in the last 20 years"
          icon="calendar alternate outline"
          value={recordsNumber}
        />
      </Grid.Column>
    </Grid>
  );
};

HomepageStatsBasic.propTypes = {
  recordsNumber: PropTypes.string,
  deimsSitesNumber: PropTypes.string,
};

export default HomepageStatsBasic;
